<template>
    <div >
        <h6 class="font-weight-normal">{{ $t(`${configId}.report.title`) }}</h6>
        <hr class="mt-2" />
        <div class="row">
            <div class="col-sm-3">
                <MaterialSelect
                    :disabled="disabled"
                    class="city-form-group city-bg"
                    id="input-report"
                    name="report"
                    label="name"
                    :filterable="true"
                    :options="lists.onoff"
                    v-model.trim="form.status"
                    :reduce="option => option.code"
                    v-validate="'required'"
                    :inputClasses="[{'is-invalid': fnHasError('report', vScope) }]"
                    :error=" fnFirstError('report', vScope)"
                    :helpText="helpReport.status">
                    {{ $t(`${configId}.report.model.status`) }}
                </MaterialSelect>
            </div>
            <div class="col-sm-9">
                <div class="form-group">
                    <MaterialInput
                        :readonly="disabled"
                        :disabled="disabled"
                        type="text"
                        class="city-form-group city-bg"
                        id="input-report-title"
                        name="report-title"
                        v-model.trim="form.title"
                        v-validate="{required: form.status == 1, 'min':3}"
                        :inputClasses="[{'is-invalid': fnHasError('report-title', vScope) }]"
                        :error=" fnFirstError('report-title', vScope)">
                        {{ $t(`${configId}.report.model.title`) }}
                    </MaterialInput>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalMixin from '@/app/shared/mixins/global';

export default {
    name: 'ConfigReportGeneral',
    mixins: [
        GlobalMixin
    ],
    components: {

    },
    inject: {
        $validator: '$validator',   // This will make the component inherit it's parent's validator scope, thus sharing all errors and validation state.
    },
    props: {
        configId: {
            type: String,
            default: 'print_manage'
        },
        value: {
            type: Object,
            default: null
        },
        vScope: {
            type: String,
            default: 'form'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        reportHelp: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            lists: {
                loaded: false,
                onoff: [{'id': 1, 'name': 'Sim', 'code': 1}, {'id': 2, 'name': 'Não', 'code': 0}],
            },
            form: {
                status: null,
                title: null,
            },
        }
    },
    beforeMount () {
        this.copyValue(this.value)
    },
    mounted() {
    },
    computed: {
        helpReport() {
            return {status: this.reportHelp ?? this.$t(`${this.configId}.report.help.status`)};
        },
    },
    methods: {
        copyValue (value) {
            Object.assign(this.form, value);
        },
    },
    watch: {
        value (newValue) {
            this.copyValue(newValue)
        },
        form: {
            handler(value, oldValue){
                this.$emit('input', value);
            },
            deep: true,
        },
    },
}
</script>

<style scoped lang="scss">

</style>
